<template>
  <vs-card class="product-card">
    <vs-row vs-w="12" class="mt-2">
      <vs-col vs-w="12" class="flex">
        <vs-input
          label="Product name"
          class="inputx mr-2"
          placeholder="Name of the product"
          v-model="product.name"
        />

        <vs-input
          label="Product description"
          class="inputx w-full"
          placeholder="Product description"
          v-model="product.description"
        />
      </vs-col>
    </vs-row>

    <vs-row vs-w="12" class="mt-2">
      <vs-col vs-w="12">
        <vs-input
          label="Product image"
          class="inputx w-full"
          placeholder="Product image url"
          v-model="product.image"
        />
      </vs-col>
    </vs-row>

    <vs-row vs-w="12" class="mt-2">
      <vs-col vs-w="12" class="flex">
        <vs-input
          label="Product price"
          class="inputx mr-2"
          type="number"
          v-model="unitPriceValue"
        />

        <div class="flex flex-col mx-2">
          <label for="" class="vs-input--label">Currency</label>
          <div class="flex h-full items-center">
            <span>
              {{ product.unitPrice.currency }}
            </span>
          </div>
        </div>

        <div class="flex flex-col">
          <label for="" class="vs-input--label">&nbsp;</label>
          <div class="flex h-full items-center">
            <ul class="flex">
              <li class="mr-2">
                <vs-radio
                  v-model="product.category"
                  :vs-name="radioButtonName"
                  vs-value="package"
                  >Package</vs-radio
                >
              </li>
              <li class="mr-2">
                <vs-radio
                  v-model="product.category"
                  :vs-name="radioButtonName"
                  vs-value="service"
                  >Service</vs-radio
                >
              </li>
              <li class="mr-2">
                <vs-radio
                  v-model="product.category"
                  :vs-name="radioButtonName"
                  vs-value="other"
                  >Other</vs-radio
                >
              </li>
            </ul>
          </div>
        </div>
      </vs-col>
    </vs-row>

    <div slot="footer">
      <vs-row vs-w="12" vs-justify="flex-end">
        <vs-button color="danger" type="filled" class="mb-2" @click="removeProduct()">
          Remove
        </vs-button>
      </vs-row>
    </div>
  </vs-card>
</template>

<script>
import * as _ from "lodash";
import { mapGetters } from "vuex";

export default {
  components: {},
  props: {
    product: {
      type: Object,
    }
  },
  data() {
    return {
      radioButtonName: 'radio-' + this.randomString()
    };
  },
  computed: {
    unitPriceValue: {
      get() {
        return this.product.unitPrice.value / 100;
      },
      set(value) {
        this.product.unitPrice.value  = value * 100;
      }
    }
  },
  methods: {
    randomString() {
      return Date.now().toString(36) + Math.random().toString(36).substr(2);
    },
    removeProduct() {
      this.$emit("product-removed", this.product);
    }
  },
};
</script>
